var _path, _path2, _g, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7508 18.9397H11.4978C11.0838 18.9397 10.7478 18.6037 10.7478 18.1897C10.7478 17.7757 11.0838 17.4397 11.4978 17.4397H18.7508C19.1648 17.4397 19.5008 17.7757 19.5008 18.1897C19.5008 18.6037 19.1648 18.9397 18.7508 18.9397Z",
    fill: "#16DBAA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_937_97",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 19
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000305176 0.000152588H17.1809V18.9397H0.000305176V0.000152588Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_937_97)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1106 2.0168L1.69558 13.7918C1.52458 14.0058 1.46158 14.2818 1.52458 14.5468L2.20558 17.4318L5.24458 17.3938C5.53358 17.3908 5.80058 17.2618 5.97758 17.0418C9.19458 13.0168 15.3276 5.3428 15.5016 5.1178C15.6656 4.8518 15.7296 4.4758 15.6436 4.1138C15.5556 3.7428 15.3246 3.4278 14.9916 3.2268C14.9206 3.1778 13.2356 1.8698 13.1836 1.8288C12.5496 1.3208 11.6246 1.4088 11.1106 2.0168ZM1.61358 18.9398C1.26658 18.9398 0.96458 18.7018 0.883579 18.3628L0.0645795 14.8918C-0.104421 14.1728 0.0635795 13.4308 0.524579 12.8548L9.94458 1.0728C9.94858 1.0688 9.95158 1.0638 9.95558 1.0598C10.9886 -0.175205 12.8566 -0.357205 14.1166 0.653795C14.1666 0.692795 15.8396 1.9928 15.8396 1.9928C16.4476 2.3548 16.9226 3.0018 17.1026 3.7678C17.2816 4.5258 17.1516 5.3078 16.7346 5.9688C16.7036 6.0178 16.6766 6.0598 7.14858 17.9798C6.68958 18.5518 6.00158 18.8848 5.26258 18.8938L1.62358 18.9398H1.61358Z",
    fill: "#16DBAA"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2234 8.68479C14.0634 8.68479 13.9034 8.63379 13.7664 8.52979L8.31436 4.34179C7.98636 4.08979 7.92436 3.61979 8.17636 3.28979C8.42936 2.96179 8.89936 2.90079 9.22836 3.15279L14.6814 7.33979C15.0094 7.59179 15.0714 8.06279 14.8184 8.39179C14.6714 8.58379 14.4484 8.68479 14.2234 8.68479Z",
    fill: "#16DBAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.d5fbdbad54679c9c1f9c13cdef4007b7.svg";
export { ForwardRef as ReactComponent };